import { QUOTE_EMAIL, COMPANY_PHONE, BRAND_LOGO_URL } from "../lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#020e12] text-white/90 mt-0 border-t border-[#d4af37]/15 overflow-hidden"
    >
      {/* Pergolaműhely watermark — silver on black panel */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-y-0 right-0 w-[34%] max-w-md"
        style={{ backgroundColor: "#000000" }}
      >
        <div
          className="absolute inset-0 bg-no-repeat bg-center bg-contain opacity-90"
          style={{
            backgroundImage: `url(${BRAND_LOGO_URL})`,
          }}
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl text-white">SolarSimple</div>
          <p className="mt-4 text-sm leading-relaxed text-white/70 max-w-md">
            Prémium minőségű alumínium pergolák, melyeket a tartós kényelem és a
            kifinomult építészeti formavilág határoz meg.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#d4af37] mb-4">Navigáció</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li>Kezdőlap</li>
            <li>Termék</li>
            <li>Konfigurátor</li>
            <li>Kapcsolat</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#d4af37] mb-4">Kapcsolat</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li>{QUOTE_EMAIL}</li>
            <li>{COMPANY_PHONE}</li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-6 text-xs text-white/50 flex justify-between">
          <span>© {new Date().getFullYear()} SolarSimple. Minden jog fenntartva.</span>
          <span>Made by Tarasola</span>
        </div>
      </div>
    </footer>
  );
}
